import { AbstractControl, ValidatorFn } from '@angular/forms'
import Fuse from 'fuse.js'

import { IQuestionOptions } from '../../model/question'
import { SelectOption } from '../'
import FuseOptions = Fuse.IFuseOptions
import { find, isArray, isFunction } from 'lodash'
import { isObservable, Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'

import { QuestionBase, QuestionOptions } from './base.question.class'

interface AutocompleteQuestionOptions extends QuestionOptions<string> {
  allowAnyValue?: boolean
  options?:
    | Observable<SelectOption<string>[]>
    | SelectOption<string>[]
    | IQuestionOptions
}

export class AutocompleteQuestion extends QuestionBase<string> {
  controlType = 'autocomplete'
  allowAnyValue = false
  declare options: (searchTerms?: string) => Observable<SelectOption<string>[]>
  private selectOptions: SelectOption<string>[]
  private fuse: Fuse<SelectOption<string>>

  constructor(options: AutocompleteQuestionOptions = {}) {
    super(options)

    if (options.allowAnyValue) {
      this.allowAnyValue = true
    }

    this.selectOptions = []

    if (isFunction(options.options)) {
      this.options = options.options as any
    } else {
      if (this.isCustom) {
        this.selectOptions = options['options']['dropdown-opts'] || []
      } else if (isArray(options.options)) {
        this.selectOptions = options.options as SelectOption<string>[]
      } else if (isObservable(options.options)) {
        this.options().subscribe(
          (selectOptions) => (this.selectOptions = selectOptions),
        )
      }
      this.options = () => of(this.selectOptions)
    }
  }

  oneOfValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      let error = null
      if (control.value) {
        error = find(this.selectOptions, { value: control.value })
          ? null
          : { oneOf: { value: control.value } }
      }
      return error
    }
  }

  getValidators() {
    const validators = super.getValidators()
    if (!this.allowAnyValue) {
      validators.push(this.oneOfValidator())
    }
    return validators
  }

  getOptions(searchTerms?: string): Observable<SelectOption<string>[]> {
    return (
      this.options(searchTerms) as Observable<SelectOption<string>[]>
    ).pipe(
      map((options: SelectOption<string>[]) => {
        const fuseOptions: FuseOptions<any> = {
          keys: ['viewValue'],
          shouldSort: true,
        }

        this.fuse = new Fuse(options, fuseOptions)

        if (searchTerms && searchTerms.length > 0) {
          return this.fuse.search(searchTerms).map((result) => result.item)
        } else {
          return options
        }
      }),
    )
  }
}
